import { BUSINESS_TOOL_SECTIONS } from 'constants/businessTool';

export const prefix = `${BUSINESS_TOOL_SECTIONS.RAISING_AND_ALLOCATING_FUNDS}` as const;

export const RAISING_AND_ALLOCATING_FUNDS_NAMES = {
  INVESTMENT_TOTAL_COST: 'investmentTotalCost',
  PROJECT_TOTAL_COST: 'projectTotalCost',
  FUNDING_DIRECTION_DETAILS: 'fundingDirectionDetails',
  EXPECTED_FUNDING_PERIOD: 'expectedFundingPeriod',
  FINANCED_PORTION_COST: 'financedPortionCost',
  FINANCED_PORTION_DESCRIPTION: 'financedPortionDescription',
  FUNDING_DESCRIPTION: 'fundingDescription',
  BORROW_DESCRIPTION: 'borrowDescription',
  LOAN_TERMS: 'loanTerms',
  RAISING_DESCRIPTION: 'raisingDescription',
  TERMS: 'terms',
  ACTIONS_IN_SEARCHING_FOR_FUNDING: 'actionsInSearchingForFunding',
  ATTRACTING_FINANCING_EXPERIENCE: 'attractingFinancingExperience',
  UTILIZING_SUPPORT_PROGRAMS: 'utilizingSupportPrograms',
} as const;

export interface IRaisingAndAllocatingFunds {
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.INVESTMENT_TOTAL_COST]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.FUNDING_DIRECTION_DETAILS]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.EXPECTED_FUNDING_PERIOD]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.FINANCED_PORTION_COST]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.FINANCED_PORTION_DESCRIPTION]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.FUNDING_DESCRIPTION]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.BORROW_DESCRIPTION]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.LOAN_TERMS]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.RAISING_DESCRIPTION]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.TERMS]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.ACTIONS_IN_SEARCHING_FOR_FUNDING]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.ATTRACTING_FINANCING_EXPERIENCE]: string;
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.UTILIZING_SUPPORT_PROGRAMS]: string;
}

export const raisingAndAllocatingFundsInitialValues: IRaisingAndAllocatingFunds = {
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.INVESTMENT_TOTAL_COST]: '',

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.FUNDING_DIRECTION_DETAILS]: '',
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.EXPECTED_FUNDING_PERIOD]: '',
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.FINANCED_PORTION_DESCRIPTION]: '',
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.FINANCED_PORTION_COST]: '',

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.FUNDING_DESCRIPTION]: '',
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.BORROW_DESCRIPTION]: '',
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.LOAN_TERMS]: '',
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.RAISING_DESCRIPTION]: '',
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.TERMS]: '',
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.ACTIONS_IN_SEARCHING_FOR_FUNDING]: '',
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.ATTRACTING_FINANCING_EXPERIENCE]: '',
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.UTILIZING_SUPPORT_PROGRAMS]: '',
};
